import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { BarChart3 } from 'lucide-react';

interface AnalyticsChartProps {
  data: Array<{
    date: string;
    followers: number;
    engagement: number;
    reach: number;
  }>;
}

export const AnalyticsChart: React.FC<AnalyticsChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-80 text-muted-foreground">
        <BarChart3 className="w-12 h-12 mb-3 opacity-40" />
        <p className="text-lg font-medium">No analytics data yet</p>
        <p className="text-sm">Connect a platform and click Refresh Data to see your analytics</p>
      </div>
    );
  }

  const chartConfig = {
    followers: {
      label: 'Followers',
      color: 'hsl(var(--chart-1))',
    },
    engagement: {
      label: 'Engagement Rate',
      color: 'hsl(var(--chart-2))',
    },
    reach: {
      label: 'Reach',
      color: 'hsl(var(--chart-3))',
    },
  };

  return (
    <ChartContainer config={chartConfig} className="h-80 w-full">
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis 
          dataKey="date" 
          tickFormatter={(value) => new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
        />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <ChartTooltip content={<ChartTooltipContent />} />
        <Line 
          yAxisId="left"
          type="monotone" 
          dataKey="followers" 
          stroke="var(--color-followers)" 
          strokeWidth={2}
          dot={{ fill: 'var(--color-followers)' }}
        />
        <Line 
          yAxisId="right"
          type="monotone" 
          dataKey="engagement" 
          stroke="var(--color-engagement)" 
          strokeWidth={2}
          dot={{ fill: 'var(--color-engagement)' }}
        />
        <Line 
          yAxisId="left"
          type="monotone" 
          dataKey="reach" 
          stroke="var(--color-reach)" 
          strokeWidth={2}
          dot={{ fill: 'var(--color-reach)' }}
        />
      </LineChart>
    </ChartContainer>
  );
};
